var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detailed-sub-header',{attrs:{"breadcrumbs":_vm.breadcrumbs,"label-name":_vm.$t('organization.assignStations.header')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }